import { AnnotationStatus } from 'modules/Annotations/store/annotationsStore';
import { types as t } from 'mst-effect';

import { withRunInAction } from 'utils/withRunInAction';

/**
 * Store that annotation status filter value
 */
export const StatusFilterStore = t
  .compose(
    withRunInAction(),
    t.model('StatusFilterStore', {
      /** Currently selected statusFilterValue  */
      statusFilterValue: t.optional(t.enumeration('statusFilterValue', Object.values(AnnotationStatus)), AnnotationStatus.Any),
    }),
  )
  .actions((self) => ({
    setStatusFilterValue: (op: AnnotationStatus) => {
      self.statusFilterValue = op;
    },
  }));
